// libs
import { useState } from "react";
import { Package, Check } from "lucide-react";

// components
import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";

// custom hooks
import useToken from "../../hooks/useToken";
import useProducts from "../../hooks/useProducts";
import useAlert from "../../hooks/useAlert";

// utils
import API from "../../utils/api";

// styles
import classes from "./styles.module.css";

export default function ProductEditModal({ productCurrentData, closeModal }) {
  const [title, setTitle] = useState(productCurrentData.title);
  const [purchase_price, setPurchase_price] = useState(
    productCurrentData.purchase_price,
  );
  const [selling_price, setSelling_price] = useState(
    productCurrentData.selling_price,
  );
  const id = productCurrentData.id;
  const [token] = useToken();
  const { editProduct } = useProducts();
  const { createAlert } = useAlert();

  const onSave = () => {
    const newData = { title, purchase_price, selling_price };
    API.putToken(`/products/${id}`, newData, token).then((d) => {
      if (d?.status === 200) {
        editProduct(id, newData);
        closeModal();
        createAlert.success("Товар обновлен");
      } else {
        createAlert.error(d.message ?? "Изменение не сохранились");
      }
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.headText}>
            <Package stroke="#009966" size={19} />
            <p>редактировать товар</p>
          </div>

          <CustomButton
            onClick={closeModal}
            className={classes.closeModalButton}
          >
            закрыть
          </CustomButton>
        </div>

        <div className={classes.hr}></div>

        <div className={classes.inputs}>
          <CustomInput
            className={`${classes.input} ${classes.titleInput}`}
            placeholder="Название товара"
            value={title}
            setValue={setTitle}
          />

          <CustomInput
            className={`${classes.input} ${classes.purchaseInput}`}
            placeholder="Цена закупки товара"
            value={purchase_price}
            setValue={setPurchase_price}
          />

          <CustomInput
            className={`${classes.input} ${classes.sellInput}`}
            placeholder="Цена продажи товара"
            value={selling_price}
            setValue={setSelling_price}
          />
        </div>

        <CustomButton className={classes.submitButton} onClick={onSave}>
          <Check size={17} />
          Сохранить изменения
        </CustomButton>
      </div>
    </div>
  );
}
